import React, { useState } from 'react';
import { Spinner } from "reactstrap";
import { Auth } from 'aws-amplify';
import Axios from 'axios';
import { API_ROUTES } from 'src/config/api';
import { useDispatch } from 'react-redux';
import { fetchOrganisations } from 'src/actions/organisationActions';

import 'react-loading-skeleton/dist/skeleton.css';

const options = [
  {
    machine_name: 'AMEX_ENABLED',
    name: 'AMEX Enabled by Default',
    description: 'Whether AMEX should be enabled by default on payment links generated in the dashboard',
  },
  {
    machine_name: 'OPEN_BANKING_ENABLED',
    name: 'Open Banking Enabled by Default',
    description: 'Whether Open Banking should be enabled by default on payment links generated in the dashboard',
  },
  {
    machine_name: 'SURCHARGING_ENABLED',
    name: 'Surcharging Enabled by Default',
    description: 'Whether surcharging should be enabled by default on payment links generated in the dashboard',
  },
    {
    machine_name: 'TOKENISATION_DISABLED',
    name: 'Tokenisation Disabled',
    description: 'Whether the tokenisation option (store card for later) should not be visible on payment pages',
  }
];

const refundOptions = [
  {
    machine_name: 'ATHORISATION_ENABLED',
    name: 'Authorisation Flow',
    description: 'Whether refunds will need to be authorised by someone in the organisation (with the auhorisation permission) before being processed',
  },
];

const recurringOptions = [
  {
    machine_name: 'CHARGE_EMAIL_AUTHENTICATION',
    name: 'Customer Authorisation',
    description: 'Whether customer authorisation (via email) should be enabled for tokenised card charges',
  },
  {
    machine_name: 'REMINDER_EMAILS',
    name: 'Payment Reminder Emails',
    description: 'Whether customers should be reminded by email about an upcoming payment. This will occur two days before the payment is due.',
  },
]

const OrganisationInformation = ({ organisation }) => {
  const hasTokenisation = organisation.payment_methods.includes('TOKENISED');

  const [changing, setChanging] = useState({});
  const dispatch = useDispatch();

  const changeStatus = async (item, status) => {
    setChanging({
      ...changing,
      [item]: true,
    });

    const user = await Auth.currentAuthenticatedUser();

    await Axios(
      API_ROUTES.user['organisation:default:update'](organisation.organisation),
      {
        method: 'post',
        data: {
          name: item,
          value: !status,
        },
        headers: { Authorization: `Bearer ${user.signInUserSession.idToken.jwtToken}` },
      }
    );

    await dispatch(fetchOrganisations());

    setChanging({
      ...changing,
      [item]: false,
    })
  };


  return (
    <React.Fragment>
      <div>

        <div>

          <h3 className="font-extralight uppercase font-mono text-2xl dark:text-white text-violet-900 mb-2 border-b border-violet-900 pb-2">
            General
          </h3>

          <div>
            <table className="table-auto w-full divide-y divide-gray-200">
              <tbody className='divide-y divide-gray-200'>

                {options.map((option, index) => (
                  <tr key={index}>
                    <td className="text-gray-700 pb-2 py-3">
                      <strong className='text-purple-900'>{option.name}</strong>
                      <br /><small>{option.description}</small>
                    </td>
                    <td className='pl-4'>
                      <div className='text-center'>
                        {changing[option.machine_name] === true && <Spinner size="sm" className="-mt-2 mr-3 text-purple-900"> </Spinner>}
                      </div>
                      {changing[option.machine_name] !== true && (
                        <div className="custom-control custom-switch float-right">
                          <input
                            type="checkbox"
                            className="custom-control-input form-control"
                            checked={organisation?.defaults[option.machine_name] === true}
                            disabled={changing[option.machine_name] === true}
                            onChange={() => changeStatus(option.machine_name, organisation?.defaults[option.machine_name])}
                            id={`${option.machine_name}-switch`}
                          />
                          <label className="custom-control-label" htmlFor={`${option.machine_name}-switch`} />
                        </div>
                      )}
                    </td>
                  </tr>
                ))}

              </tbody>
            </table>

          </div>
        </div>
      </div>

      <div className='mt-4'>
        <div>
          <h3 className="font-extralight uppercase font-mono text-2xl dark:text-white text-violet-900 mb-2 border-b border-violet-900 pb-2">
            Refunds
          </h3>
          <div>
            <table className="table-auto w-full divide-y divide-gray-200">
              <tbody className='divide-y divide-gray-200'>
                {refundOptions.map((option, index) => (
                  <tr key={index}>
                    <td className="text-gray-700 pb-2 py-3">
                      <strong className='text-purple-900'>{option.name}</strong>
                      <br /><small>{option.description}</small>
                    </td>
                    <td className='pl-4'>
                      <div className='text-center'>
                        {changing[option.machine_name] === true && <Spinner size="sm" className="-mt-2 mr-3 text-purple-900"> </Spinner>}
                      </div>
                      {changing[option.machine_name] !== true && (
                        <div className="custom-control custom-switch float-right">
                          <input
                            type="checkbox"
                            className="custom-control-input form-control"
                            checked={organisation?.defaults[option.machine_name] === true}
                            disabled={changing[option.machine_name] === true}
                            onChange={() => changeStatus(option.machine_name, organisation?.defaults[option.machine_name])}
                            id={`${option.machine_name}-switch`}
                          />
                          <label className="custom-control-label" htmlFor={`${option.machine_name}-switch`} />
                        </div>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {hasTokenisation === true && (
        <div className='mt-4'>

          <div>

            <h3 className="font-extralight uppercase font-mono text-2xl dark:text-white text-violet-900 mb-2 border-b border-violet-900 pb-2">
              Recurring Payments
            </h3>

            <div>
              <table className="table-auto w-full divide-y divide-gray-200">
                <tbody className='divide-y divide-gray-200'>

                  {recurringOptions.map((option, index) => (
                    <tr key={index}>
                      <td className="text-gray-700 pb-2 py-3">
                        <strong className='text-purple-900'>{option.name}</strong>
                        <br /><small>{option.description}</small>
                      </td>
                      <td className='pl-4'>
                        <div className='text-center'>
                          {changing[option.machine_name] === true && <Spinner size="sm" className="-mt-2 mr-3 text-purple-900"> </Spinner>}
                        </div>
                        {changing[option.machine_name] !== true && (
                          <div className="custom-control custom-switch float-right">
                            <input
                              type="checkbox"
                              className="custom-control-input form-control"
                              checked={organisation?.defaults[option.machine_name] === true}
                              disabled={changing[option.machine_name] === true}
                              onChange={() => changeStatus(option.machine_name, organisation?.defaults[option.machine_name])}
                              id={`${option.machine_name}-switch`}
                            />
                            <label className="custom-control-label" htmlFor={`${option.machine_name}-switch`} />
                          </div>
                        )}
                      </td>
                    </tr>
                  ))}

                </tbody>
              </table>

            </div>
          </div>
        </div>
      )}

    </React.Fragment>
  );
}

export default OrganisationInformation;